<div class="card card-primary card-outline style">
  <div class="card-body box-profile">

    <p class="style1">     
     <b>{{name}}</b>
     </p>

 <div class="card-body"  *ngFor="let c of output">
  <strong class="distance2">Visited By :</strong>
  {{c.employee_name}}
  <hr>


  <strong class="distance3">Date And Time :</strong>
  {{todayWithPipe}}
  <hr>

  <strong class="distance4">Purpose :</strong>
  {{c.visit_purpose}}
  <hr>

  <strong class="distance6">Invoice Number :</strong>
  {{c.invoice_number}}
  <hr>
  
  <strong class="distance5">Remarks :</strong>
  {{c.remarks}}
  
</div>
<!---------google map---------------------------->
<!-- Use custom zoom buttons --
<button (click)="zoomIn()">Zoom in</button>
<button (click)="zoomOut()">Zoom out</button>
<google-map height="500px" width="100%"  [center]="center"></google-map>
--->
<google-map height="500px" width="100%"  [center]="center"  [zoom]="zoom">
  <map-marker
    *ngFor="let marker of markers"
    [position]="marker.position"
    [label]="marker.label"
    [title]="marker.title"
    [options]="marker.options"
  >
  </map-marker>
</google-map>

<!-------------
<div class="card">
<form class="center">
<h1>Customer Visit Details</h1>
    <div class="settings" *ngFor="let c of output">

      <label>Customer Name:</label><label>{{c.customer_name}}</label>
      
      <label>Visited By:</label><label>{{c.employee_name}}</label>
     
      <label>Date and Time:</label><label>{{todayWithPipe}}</label>
     
      <label>Visit Purpose:</label><label>{{c.visit_purpose}}</label>
     
      <label>Remarks:</label><label>{{c.remarks}}</label>
      
</div>
</form></div>
------->